import CustomPaginator from './CustomPaginator';

export default CustomPaginator;
